/*!
 * Ansar Law Firm
 */
(function ($)
{
	'use strict';
	
	var alf_body = $(document.body);
	
	$.alf = $.alf || {};
	$.alf.cookies = $.alf.cookies || {};
	$.alf.data = $.alf.data || {};
	$.alf.events = $.alf.events || {};
	$.alf.get = $.alf.get || {};
	$.alf.prepare = $.alf.prepare || {};
	
	$.extend($.alf.cookies,
	{
		"delete": function (key)
		{
			$.alf.cookies.set(key, '', -1);
		},
		
		"get": function (key)
		{
			key = key + '=';
			
			var i = 0;
			var cookies = document.cookie.split(';');
			
			for (i; i < cookies.length; i++)
			{
				var cookie = cookies[i].trim();
				
				if (cookie.indexOf(key) === 0)
				{
					return cookie.substring(key.length, cookie.length);
				}
			}
			
			return '';
		},
		
		"set": function (key, value, days)
		{
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			
			document.cookie = key + '=' + value + ';expires=' + date.toGMTString() + ';path=/';
		}
	});
	
	$.extend($.alf.data,
	{
		"menu": 'menu'
	});
	
	$.extend($.alf.events,
	{
		"close": 'alf-close',
		"scale": 'alf-scale'
	});
	
	$.extend($.alf.get,
	{
		"breakpoint": function ()
		{
			return $('#theme-breakpoint').height();
		},
		
		"query_string": function (name)
		{
			var regex = new RegExp('[\\?&]' + name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]') + '=([^&#]*)');
			var results = regex.exec(location.search);
			
			return (results !== null) ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
		}
	});
	
	$.extend($.alf.prepare,
	{
		"cookies": function ()
		{
			if ($.alf.cookies.get('cookie-policy') === '' || $.alf.get.query_string('force') === 'true')
			{
				$('.alf-cookies').first().show().find('a')
				.click(function ()
				{
					$.alf.cookies.set('cookie-policy', true, 365);
				})
				.filter('.alf-close')
				.click(function ()
				{
					$(this).closest('.alf-cookies').slideUp();
				});
			}
		},
		
		"left_navigation": function ()
		{
			var menu = $('#menu-main-menu li.menu-item-has-children.active').last();
			
			if (menu.length > 0)
			{
				var heading = $('<h3/>').append(menu.children('a').clone());
				
				var ul = menu.children('ul').clone();
				ul.find('ul').remove();
				
				$('.alf-left-navigation')
				.each(function ()
				{
					var current = $(this).empty();
					heading.clone().appendTo(current);
					ul.clone().appendTo(current);
				});
				
				heading.remove();
				ul.remove();
			}
		},
		
		"mobile_menu": function ()
		{
			var menu_toggle = $('#mobile-menu');
			var menu_ul = $('<ul/>').append($('#menu-main-menu > li').not('.search').clone());
			
			var menu_wrapper = $('<div/>').attr('id', 'mobile-main-menu').append(menu_ul).insertAfter(menu_toggle)
			.alf_add_event($.alf.events.scale, function ()
			{
				$(this).css('max-height', ($(window).height() - $('#site-header').height() - $('#site-navigation').height() - $('#wpadminbar').height()) + 'px');
			});
			
			menu_toggle.data($.alf.data.menu, menu_wrapper)
			.click(function ()
			{
				var clicked = $(this);
				var menu = clicked.data($.alf.data.menu).stop(true);
				
				if (clicked.hasClass('open'))
				{
					clicked.removeClass('open');
					menu.slideUp();
				}
				else
				{
					clicked.addClass('open');
					menu.slideDown();
				}
			});
			
			var menu_subs = menu_ul.find('.menu-item-has-children');
			menu_subs.filter('.active').addClass('open');
			
			menu_subs
			.on($.alf.events.close, function ()
			{
				$(this).removeClass('open').children('ul').stop(true).slideUp();
			})
			.children('a')
			.click(function (e)
			{
				var parent = $(this).parent();
				
				if (!parent.hasClass('open'))
				{
					e.preventDefault();
					
					parent.siblings('.open').alf_trigger_all($.alf.events.close);
					
					parent.addClass('open').children('ul').stop(true).slideDown();
				}
			});
		},
		
		"search": function ()
		{
			$('.search-form')
			.each(function ()
			{
				var search = $(this);
				
				search.find('form')
				.submit(function ()
				{
					if ($(this).find('input').val() === '')
					{
						return false;
					}
				});
				
				search.find('input')
				.blur(function ()
				{
					var input = $(this);
					var button = input.closest('.search-form').find('button');

					if (!button.hasClass('hover'))
					{
						input.stop(true).fadeOut('fast');
					}
				});
				
				search.find('button')
				.hover(function ()
				{
					$(this).addClass('hover').closest('.search-form').find('input').stop(true)
					.fadeIn('fast', function ()
					{
						$(this).focus();
					});
				},
				function ()
				{
					$(this).removeClass('hover');
				});
			});
			
			$('#menu-main-menu')
			.mouseenter(function ()
			{
				$('.search-form').find('input').blur();
			});
		},
		
		"site_content": function ()
		{
			$('#site-content')
			.alf_add_event($.alf.events.scale, function ()
			{
				$(this).css('min-height', ($(window).height() - $('#site-header').height() - $('#site-navigation').height() - $('#site-breadcrumb').outerHeight() - $('#site-footer').outerHeight() - $('#wpadminbar').height()) + 'px');
			});
		},
		
		"team": function ()
		{
			$('.team-members')
			.alf_add_event($.alf.events.scale, function ()
			{
				$(this).children('.team-member').children('.name').alf_equalize_height();
			});
		}
	});
	
	$.fn.extend(
	{
		"alf_add_event": function (e, f)
		{
			return this.addClass(e).on(e, f).alf_trigger_all(e);
		},
		
		"alf_equalize_height": function ()
		{
			var tallest = 0;
			
			return this.css('min-height', '')
			.each(function ()
			{
				var height = $(this).height();
				tallest = (height > tallest) ? height : tallest;
			})
			.css('min-height', tallest + 'px');
		},
		
		"alf_trigger_all": function (e)
		{
			return this
			.each(function ()
			{
				$(this).triggerHandler(e);
			});
		}
	});
	
	alf_body.addClass('loading');
	
	$.alf.prepare.cookies();
	$.alf.prepare.left_navigation();
	$.alf.prepare.mobile_menu();
	$.alf.prepare.search();
	$.alf.prepare.site_content();
	$.alf.prepare.team();
	
	$(window)
	/*.on('beforeunload', function ()
	{
		alf_body.removeClass('loaded');
		
		setTimeout(function ()
		{
			$('#outer-site-wrapper').hide();
		},
		400);
	})*/
	.resize(function ()
	{
		$('.' + $.alf.events.scale).alf_trigger_all($.alf.events.scale);
	});
	
	$(document)
	.ready(function ()
	{
		$('.' + $.alf.events.scale).alf_trigger_all($.alf.events.scale);
	});
	
	alf_body.addClass('loaded').removeClass('loading');
})
(jQuery);
